// LiveStreamGoalItem.js
import { connect } from 'react-redux';

import LiveStreamGoalItem from '../component/LiveStreamGoalItem.jsx';
import getGoalData from '../selector/getGoalData.js';
import getUserData from '../selector/getUserData.js';
import fetchUser from '../action/fetchUser.js';

const mapStateToProps = (state, { goalId }) => {
  const started = getGoalData(state, [goalId], 'started');
  const levels = getGoalData(state, [goalId], 'levels')?.[0] || {};
  const senderId = getGoalData(state, [goalId, 'context'], 'sender_id');
  const productId = getGoalData(state, [goalId, 'context'], 'product_id');
  const senderUsername = getUserData(state, senderId, 'username');
  return {
    started,
    senderId,
    senderUsername,
    productId,
    goalTitle: levels?.title,
    target: levels?.target,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUser: ({ userId }) => dispatch(fetchUser({ id: userId })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LiveStreamGoalItem);
